import exp from "constants";
import AddPackageForm from "./components/AddPackageForm";
import { ChangeEvent, FormEvent, useEffect, useState } from "react";
import {
  AddPackageInput,
  AddPackageInputError,
  Packages,
  VideoDetailProps,
} from "../store/actionType";
import { connect, useSelector } from "react-redux";
import { addPackageToVideoFeatured, resetVideo } from "../store/action";
import { ApiError } from "components";
interface OwnProps {
  videoPackages: Packages[];
  videoData: VideoDetailProps;
  closeModal: () => void;
}

type DispatchProps = ReturnType<typeof mapDispatchToProps>;
type Props = DispatchProps & OwnProps;
const HandleAddPackagesToVideo: React.FC<Props> = ({
  videoPackages,
  videoData,
  closeModal,
  onAddPackageToVideo,
  onResetVideo,
}) => {
  const refId = videoPackages?.map((pkg) => pkg.ref_id)[0];
  const contentType = videoPackages?.map((pkg) => pkg.content_type)[0];
  const videoDetailsState = useSelector(
    (state: any) => state.videoDetails?.addPackageToVideoState
  );
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState<AddPackageInput>({
    package_ids: videoPackages?.map((pkg) => pkg.package_id) || [],
    content_type: contentType || "",
    ref_id: refId || videoData?.id.toString() || "",
  });
  const [error, setError] = useState<AddPackageInputError>({});
  const [apiError, setApiError] = useState<string | null>(null);
  const [submitted, setSubmitted] = useState(false);
  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const handleSave = async (e: FormEvent) => {
    e.preventDefault();
    var input: AddPackageInput = {
      ref_id: videoData?.id.toString() || refId,
      package_ids: formData.package_ids,
      content_type: "Video",
    };
    if (formData.package_ids.length === 0) {
      setError({ package_ids: "Please select a package" });
      return;
    } else {
      setLoading(true);
      setSubmitted(true);
      onAddPackageToVideo(input);
      setLoading(false);
    }
  };
  useEffect(() => {
    if (!videoDetailsState.isLoading && submitted) {
      if (videoDetailsState.error) {
        setApiError(videoDetailsState.error); // show error
      } else {
        setApiError(null);
        closeModal();
      }
    }
  }, [videoDetailsState.isLoading, videoDetailsState.error, submitted]);
  return (
    <div>
      <AddPackageForm
        onClose={closeModal}
        loading={loading}
        header={`${videoPackages?.length > 0 ? "Update" : "Add"} Package to Video`}
        formData={formData}
        error={error}
        handleChange={handleChange}
        handleSubmit={handleSave}
      />
      {apiError && <ApiError>{apiError}</ApiError>}
    </div>
  );
};
const mapDispatchToProps = (dispatch: any) => ({
  onAddPackageToVideo: (input: AddPackageInput) =>
    dispatch(addPackageToVideoFeatured(input)),
  onResetVideo: () => dispatch(resetVideo()),
});

export default connect(null, mapDispatchToProps)(HandleAddPackagesToVideo);
